import React from 'react';
import Footer from './Footer';
import './TravelInfo.css';

const airportOptions = [
    {
        name: 'Bradley International Airport (BDL)',
        location: 'Springfield, MA • ~1 hour drive',
        description: 'The closest major airport to the venue. A scenic drive through the Berkshires brings you right to New Marlborough. All else equal, we recommend flying in here.',
        directionsUrl: 'https://www.google.com/maps/dir/Bradley+International+Airport,+Schoephoester+Road,+Windsor+Locks,+CT/New+Marlborough,+MA'
    },
    {
        name: 'Boston Logan International (BOS)',
        location: 'Boston, MA • ~2.5 hour drive',
        description: 'Boston is a larger airport, with more flight options available. It may also be a cheaper option depending when you\'re coming from. Traffic can vary depending on timing— we recommend avoiding rush hour if possible.',
        directionsUrl: 'https://www.google.com/maps/dir/Boston+Logan+International+Airport,+Boston,+MA/New+Marlborough,+MA'
    },
    {
        name: 'Albany International Airport (ALB)',
        location: 'Albany, NY • ~1 hour 20 minute drive',
        description: 'Albany is another option which may be convenient depending on origin. However, for most, Bradley has similar flight connections and is a bit closer to the venue.',
        directionsUrl: 'https://www.google.com/maps/dir/Albany+International+Airport,+Albany,+NY/New+Marlborough,+MA'
    }
];

const lodgingCategories = [
    {
        title: 'At the Venue',
        places: [
            {
                name: 'Old Inn on the Green',
                status: 'Fully booked',
                description: 'This is where the reception will be held, and it is next door to the ceremony location. The whole inn is reserved for the wedding party and guests and will be used as a gathering point throughout the weekend.',
                badge: '★ At Venue',
                url: 'https://oldinn.com/',
                featured: true
            }
        ]
    },
    {
        title: 'New Marlborough',
        places: [
            {
                name: 'Freeman Elms Farm B&B',
                details: '9 min drive',
                status: 'Fully booked',
                description: "Lodging for the groom's side of the wedding party.",
                url: 'https://www.freemanelmsfarm.com/'
            }
        ]
    },
    {
        title: 'Great Barrington',
        description: 'Recommended options with shops and restaurants nearby. (~20 min drive to the venue)',
        compact: true,
        places: [
            {
                name: 'Quality Inn',
                details: '~$120/night',
                status: "Wedding Block",
                url: 'https://www.qualityinngreatbarrington.com/',
                description: 'Wedding block available; to book, call and say you are with the Promislow/Jeffries wedding! 2-night minimum stay for reserved block price. Must book by the end of July.'
            },
            {
                name: 'Holiday Inn Express',
                details: '~$185/night',
                status: "Wedding Block",
                url: 'https://www.ihg.com/holidayinnexpress/hotels/us/en/find-hotels/select-roomrate?qDest=415%20Stockbridge%20Road,%20Great%20Barrington,%20MA,%20US&qPt=CASH&qCiD=11&qCoD=13&qCiMy=082026&qCoMy=082026&qAdlt=1&qChld=0&qRms=1&qRtP=6CBARC&qGrpCd=PJW&qSlH=GBRMA&srb_u=1&qFS=false&qSrt=sBR&qBrs=6c.hi.ex.sb.ul.ic.cp.cw.in.vn.cv.rs.ki.kd.ma.sp.va.sp.re.vx.nd.sx.we.lx.rn.sn.sn.sn.sn.sn.nu.ge.fa&qWch=0&qSmP=0&qRad=30&qRdU=mi&setPMCookies=false&qpMbw=0&qErm=false&qpMn=1&qRmFltr=',
                description: 'Wedding block available; to book, use the link above which links directly to the Promislow/Jeffries reserved block, or call for assistance. 2-night minimum stay for reserved block price. Must book by July.'
            },
            {
                name: 'Monument Mountain Motel',
                url: 'http://www.monumentmountainmotel.com/'
            },
            {
                name: 'Travelodge by Wyndham',
                url: 'https://www.wyndhamhotels.com/travelodge/great-barrington-massachusetts/travelodge-great-barrington-berkshires/overview'
            }
        ]
    },
    {
        title: 'Berkshire Vacation Stays',
        description: 'Good options for larger groups, families, or guests hoping to make the weekend feel like a Berkshire getaway. Many places can be found within 20-30 min of the venue.',
        places: [
            {
                name: 'Airbnb homes near New Marlborough',
                details: 'Private homes and cottages',
                description: 'A good place to look if you are traveling with a group, want a kitchen, or prefer a whole-house stay.',
                url: 'https://www.airbnb.com/new-marlborough-ma/stays'
            },
            {
                name: 'Wilder House Berkshires',
                details: 'Sheffield B&B',
                description: 'A small vintage inn in Sheffield with modern updates and a Southern Berkshires home-base feel.',
                url: 'https://www.wilderhouseberkshires.com/'
            },
            {
                name: 'The Berkshire Mountain Inn',
                details: 'Great Barrington inn',
                description: 'A historic inn about a half mile from downtown Great Barrington.',
                url: 'https://www.theberkshiremountaininn.com/'
            },
            {
                name: 'The Inn at Stockbridge',
                details: 'Stockbridge B&B',
                description: 'A peaceful inn on landscaped grounds, with multiple lodging houses for a classic Stockbridge getaway.',
                url: 'https://www.stockbridgeinn.com/'
            },
            {
                name: 'Doctor Sax House',
                details: 'Lenox boutique hotel',
                description: 'A stylish nine-room boutique stay in historic Lenox Village, with a restaurant and bar on site.',
                url: 'https://www.doctorsaxhouse.com/'
            }
        ]
    }
];

const travelTips = [
    {
        title: 'Cell Service Spotty',
        text: 'Cell service in the area can be poor and sometimes nonexistant. We recommend to download a map of the area to your smartphone, or otherwise look up directions in advance.'
    },
    {
        title: 'Tick Activity',
        text: 'The northeast and the berkshires are known for tick activity, and this year they are particularly prevalent. Please familiarize yourself with tick prevention and handling, and perform tick checks regularly while in the area.'
    },
    {
        title: 'Rental Car Recommended',
        text: 'The venue and accommodations are in a rural area— a rental car will make getting around much easier. However, be careful about driving too fast on Route 7 through Great Barrington; there is sometimes a speed trap that targets visitors.'
    },
    {
        title: 'Book Early',
        text: 'September is a popular time in the Berkshires for fall foliage. We recommend booking accommodations sooner rather than later.'
    },
    {
        title: 'Pack Layers',
        text: 'Early fall in New England can be unpredictable. Bring layers for varying temperatures throughout the day.'
    }
];

function SectionHeader({ title, subtitle }) {
    return (
        <div className="section-header">
            <h2 className="section-title">{title}</h2>
            <span className="section-subtitle">{subtitle}</span>
        </div>
    );
}

function AirportOption({ airport }) {
    return (
        <div className="airport-card">
            <div className="airport-info">
                <h3>{airport.name}</h3>
                <p className="airport-location">{airport.location}</p>
                <p className="airport-description">{airport.description}</p>
                <a
                    href={airport.directionsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="map-link"
                >
                    View Directions →
                </a>
            </div>
        </div>
    );
}

function LodgingPlace({ place }) {
    return (
        <div className={`lodging-card${place.featured ? ' featured' : ''}`}>
            <div className="lodging-info">
                <h4>{place.name}</h4>
                <p className="lodging-details">{place.details}</p>
                {place.status && <p className="lodging-status lodging-status-booked">{place.status}</p>}
                {place.description && <p className="lodging-description">{place.description}</p>}
                {place.badge && <span className="lodging-badge">{place.badge}</span>}
            </div>
            <a href={place.url} target="_blank" rel="noopener noreferrer" className="lodging-link">
                View →
            </a>
        </div>
    );
}

function LodgingCategory({ category }) {
    const places = category.places.map((place) => (
        <LodgingPlace place={place} key={place.name} />
    ));

    return (
        <div className="lodging-category">
            <div className="category-header">
                <h3>{category.title}</h3>
                <span className="category-line"></span>
            </div>
            {category.description && <p className="category-description">{category.description}</p>}

            {category.compact ? <div className="lodging-grid">{places}</div> : places}
        </div>
    );
}

function TravelTip({ tip }) {
    return (
        <div className="tip-item">
            <div className="tip-content">
                <h4>{tip.title}</h4>
                <p>{tip.text}</p>
            </div>
        </div>
    );
}

function TravelInfo() {
    return (
        <div className="travel">
            <header className="page-header">
                <br /><br />
                <div className="page-header-image-layer" aria-hidden="true"></div>
                <h1>Travel & Accommodations</h1>
                <p></p>
                <br />
            </header>

            <div className="botanical-wrapper">
                <div className="botanical-left"></div>
                <div className="botanical-right"></div>

                <section className="travel-section">
                    <SectionHeader title="Getting There" subtitle="Airport Options" />

                    <div className="airports-list">
                        {airportOptions.map((airport) => (
                            <AirportOption airport={airport} key={airport.name} />
                        ))}
                    </div>
                </section>

                <section className="travel-section secondary">
                    <SectionHeader title="Where to Stay" subtitle="Accommodations" />

                    {lodgingCategories.map((category) => (
                        <LodgingCategory category={category} key={category.title} />
                    ))}
                </section>

                <section className="travel-section">
                    <SectionHeader title="Travel Tips" />

                    <div className="tips-list">
                        {travelTips.map((tip) => (
                            <TravelTip tip={tip} key={tip.title} />
                        ))}
                    </div>
                </section>
            </div>

            <Footer />
        </div>
    );
}

export default TravelInfo;
